import React from 'react';
import { IHocSinh } from '../../../models/response/crm-hocsinh/IHocsinh';
import { Controller, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import FormBlock from './FormBlock';
import { Box, FormControl } from '@primer/react';
import { ComboboxTruong } from '../../../components/combobox-truong';
import ComboboxKhoi from '../../../components/combobox-khoi';
import ComboboxHe from '../../../components/combobox-he';
import ComboboxLop from '../../../components/combobox-lop';
interface IThongTinDangKyProps {
    control: any,
    hocSinh: IHocSinh,
    setFormData: React.Dispatch<React.SetStateAction<IHocSinh>>,
    setValue: UseFormSetValue<IHocSinh>,
    generatedCode?: string,
    register: any,
    errors: any,
    formData: IHocSinh,
    trigger: UseFormTrigger<IHocSinh>

}
const ThongTinDangKy = (props: IThongTinDangKyProps) => {
    const { control, setFormData, hocSinh, setValue, generatedCode, register, errors, formData, trigger } = props;
    const handleTruongChange = (value: number) => {
        setFormData((prev) => ({
            ...prev,
            dm_truong_id: value,
            dm_khoi_id: 0,
            dm_he_id: 0,
            dm_lop_id: 0,
        }));
        setValue("dm_truong_id", value);
        setValue("dm_khoi_id", 0);
        setValue("dm_he_id", 0);
        setValue("dm_lop_id", 0);
    };
    const handleKhoiChange = (value: number) => {
        setFormData((prev) => ({
            ...prev,
            dm_khoi_id: value,
            dm_he_id: 0,
            dm_lop_id: 0,
        }));
        setValue("dm_khoi_id", value);
        setValue("dm_he_id", 0);
        setValue("dm_lop_id", 0);
    };
    const handleHeChange = (value: number) => {
        setFormData((prev) => ({
            ...prev,
            dm_he_id: value,
            dm_lop_id: 0,
        }));
        setValue("dm_he_id", value);
        setValue("dm_lop_id", 0);
    };
    return (
        <FormBlock caption="Thông tin đăng ký">
            <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: "repeat(4, 1fr)" }}>

                <Controller
                    name="dm_truong_id"
                    control={control}
                    rules={{
                        validate: (value) => (value && value > 0) || "Vui lòng Chọn cấp học"
                    }}
                    render={({ field }) => (
                        <>
                            <FormControl>
                                <FormControl.Label>
                                    Chọn cấp học <span style={{ color: "red" }}>*</span>
                                </FormControl.Label>
                                <ComboboxTruong
                                    value={field.value}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        handleTruongChange(value);
                                    }}
                                />
                                {errors.dm_truong_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_truong_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        </>
                    )}
                />

                <Controller
                    name="dm_khoi_id"
                    control={control}
                    rules={{
                        validate: (value) => (value && value > 0) || "Vui lòng chọn khối"
                    }}
                    render={({ field }) => (
                        <>
                            <FormControl>
                                <FormControl.Label>
                                    Chọn khối <span style={{ color: "red" }}>*</span>
                                </FormControl.Label>
                                <ComboboxKhoi
                                    dm_truong_id={formData.dm_truong_id}
                                    value={field.value}
                                    disabled={!formData.dm_truong_id || formData.dm_truong_id <= 0}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        handleKhoiChange(value);
                                    }}
                                />
                                {errors.dm_khoi_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_khoi_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        </>
                    )}
                />

                <Controller
                    name="dm_he_id"
                    control={control}
                    rules={{
                        validate: (value) => (value && value > 0) || "Vui lòng chọn hệ"
                    }}
                    render={({ field }) => (
                        <>
                            <FormControl>
                                <FormControl.Label>
                                    Chọn hệ <span style={{ color: "red" }}>*</span>
                                </FormControl.Label>
                                <ComboboxHe
                                    value={field.value}
                                    dm_khoi_id={formData.dm_khoi_id}
                                    dm_truong_id={formData.dm_truong_id}
                                    disabled={!formData.dm_khoi_id || formData.dm_khoi_id <= 0}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        handleHeChange(value);
                                    }}
                                />
                                {errors.dm_he_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_he_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        </>
                    )}
                />

                <Controller
                    name="dm_lop_id"
                    control={control}
                    rules={{
                        validate: (value) => (value && value > 0) || "Vui lòng chọn lớp"
                    }}
                    render={({ field }) => (
                        <>
                            <FormControl>
                                <FormControl.Label>
                                    Chọn lớp <span style={{ color: "red" }}>*</span>
                                </FormControl.Label>
                                <ComboboxLop
                                    dm_truong_id={formData.dm_truong_id}
                                    nam_hoc={formData.nam_hoc}
                                    dm_khoi_id={formData.dm_khoi_id}
                                    dm_he_id={formData.dm_he_id}
                                    value={field.value}
                                    disabled={!formData.dm_he_id || formData.dm_he_id <= 0 || !formData.dm_khoi_id || formData.dm_khoi_id <= 0 || !formData.dm_truong_id || formData.dm_truong_id <= 0}
                                    onValueChanged={(value) => {
                                        field.onChange(value);
                                        setValue("dm_lop_id", value);
                                        setFormData((prev) => ({
                                            ...prev,
                                            dm_lop_id: value,
                                        }));
                                    }}
                                />
                                {errors.dm_lop_id && (
                                    <FormControl.Validation variant="error">
                                        {errors.dm_lop_id.message}
                                    </FormControl.Validation>
                                )}
                            </FormControl>
                        </>
                    )}
                />



            </Box>
        </FormBlock>
    );
};

export default ThongTinDangKy;